module.exports = function() {
  return new Worker(__webpack_public_path__ + "131f222c5c4672b4e782.worker.js");
};